// WARNING: never direct import from this file
// Theme files are loaded asynchronously

import { sharedOverrides as Shared, sharedCustomVars } from './shared'
import { cloneDeep } from 'lodash-es'
import type { GlobalThemeOverrides } from 'naive-ui'

// Custom theme variables
export const customVars: TCustomThemeVars = {
  // overwrite custom vars below, for the light theme
  ...cloneDeep(sharedCustomVars),
}

export const themeOverrides: GlobalThemeOverrides = {
  common: {
    ...Shared.common,
  },
  Alert: {
    ...Shared.Alert,
  },
  Breadcrumb: {
    ...Shared.Breadcrumb,
  },
  Button: {
    ...Shared.Button,
  },
  Card: {
    ...Shared.Card,
  },
  Checkbox: {
    ...Shared.Checkbox,
  },
  ColorPicker: {
    ...Shared.ColorPicker,
  },
  DataTable: {
    ...Shared.DataTable,
    tdColorHover: sharedCustomVars.cGray[100],
    thColorHover: sharedCustomVars.cGray[100],
  },
  Dialog: {
    ...Shared.Dialog,
  },
  Form: {
    ...Shared.Form,
  },
  Input: {
    ...Shared.Input,
  },
  LoadingBar: {
    ...Shared.LoadingBar,
  },
  Pagination: {
    ...Shared.Pagination,
  },
  Popover: {
    ...Shared.Popover,
    color: '#ffffff',
  },
  Progress: {
    ...Shared.Progress,
    Skeleton: {
      ...Shared.Skeleton,
    },
  },
  Skeleton: {
    ...Shared.Skeleton,
  },
  Steps: {
    ...Shared.Steps,
  },
  Tabs: {
    ...Shared.Tabs,
  },
  Tag: {
    ...Shared.Tag,
  },
  Tooltip: {
    textColor: 'rgb(51, 54, 57)',
  },
  Typography: {
    ...Shared.Typography,
  },
  Notification: {
    ...Shared.Notification,
  },
}
